import AdUnitsPage from "./ad-units";

export default function UgcTemplatesPage() {
  return <AdUnitsPage mode="ugc" />;
}
